'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// @ts-nocheck
exports.default = {
    saveSettingsButtonString: 'Opslaan',
    title: 'Wijzigen'
};